import {ArrowForward} from '@mui/icons-material';
import {Button} from '@mui/material';
import React from 'react';
import {useMediaQuery} from 'react-responsive';
import styled, {keyframes} from 'styled-components';
import {Link} from 'react-router-dom';

import PontoIreit from '../../Assets/PontoIreit.jpg';

const fadeInRight = keyframes`
  0%   { transform: translateX(6em);  opacity: 0; }
  50%  { transform: translateX(6em);  opacity: 0; }
  100% { transform: translateX(0em);  opacity: 1; }
`;

const fadeInLeft = keyframes`
  0%   { transform: translateX(-6em); opacity: 0; }
  50%  { transform: translateX(-6em); opacity: 0; }
  100% { transform: translateX(0em);  opacity: 1; }
`;

const EnterFromLeft = styled.div`
  animation-fill-mode: forwards;
  animation: 1000ms ${fadeInLeft} linear;
`;

const EnterFromRight = styled.div`
  animation-fill-mode: forwards;
  animation: 1000ms ${fadeInRight} linear;
`;

const Ponto = () => {
  const isSmall = useMediaQuery({query: '(max-width: 750.98px)'});
  const isVerySmall = useMediaQuery({query: '(max-width:450.00px)'});

  return (
    <div>
      {isVerySmall || isSmall ? (
        /* ───── MOBILE ───── */
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 'auto',
            marginTop: 0,
            display: 'flex',
            paddingBottom: 60,
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {/* Background image */}
          <img
            src={PontoIreit}
            alt=""
            aria-hidden="true"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
          {/* Blue overlay — blends into footer below */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(180deg, rgba(6,68,142,0.82) 0%, rgba(6,68,142,0.88) 60%, #06448e 100%)',
            }}
          />

          {/* Content */}
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: 16,
              marginRight: 16,
              width: '100%',
            }}
          >
            {/* Pill badge */}
            <div
              style={{
                marginTop: 36,
                background: 'rgba(255,102,0,0.18)',
                border: '1px solid rgba(255,102,0,0.5)',
                borderRadius: 20,
                padding: '5px 16px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  background: '#FF6600',
                  display: 'inline-block',
                }}
              />
              <p
                style={{
                  margin: 0,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#FF6600',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Novo Recurso
              </p>
            </div>

            {/* Heading */}
            <EnterFromLeft>
              <p
                style={{
                  fontSize: 36,
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  marginTop: 16,
                  marginBottom: 0,
                  textAlign: 'center',
                  lineHeight: 1.1,
                }}
              >
                Cadastre seu <span style={{color: '#FF6600'}}>ponto</span>
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: 'rgba(255,255,255,0.55)',
                  marginTop: 6,
                  marginBottom: 0,
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                }}
              >
                e gerencie sua frota
              </p>
            </EnterFromLeft>

            {/* Card image (moto point) */}
            <EnterFromRight style={{width: '90%', marginTop: 24}}>
              <img
                style={{
                  width: '100%',
                  height: 200,
                  borderRadius: 14,
                  objectFit: 'cover',
                  boxShadow:
                    '0 16px 48px rgba(0,0,0,0.5), 0 0 0 2px rgba(255,102,0,0.35)',
                  display: 'block',
                }}
                src={PontoIreit}
                alt="Ponto de mototáxi IREIT"
              />
            </EnterFromRight>

            {/* Description */}
            <EnterFromLeft>
              <p
                style={{
                  fontSize: 18,
                  color: 'rgba(255,255,255,0.75)',
                  marginTop: 24,
                  marginBottom: 0,
                  textAlign: 'center',
                  lineHeight: 1.6,
                  paddingLeft: 8,
                  paddingRight: 8,
                }}
              >
                Donos de pontos de mototáxi, táxi e carros de aplicativo podem
                criar seus pontos, vincular sua frota e gerenciar tudo em um só
                lugar.
              </p>
            </EnterFromLeft>

            {/* Stats */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 32,
                marginTop: 28,
                paddingTop: 20,
                borderTop: '1px solid rgba(255,255,255,0.12)',
                width: '90%',
              }}
            >
              {[{num: '100%', label: 'Gratuito'}].map(s => (
                <div key={s.label} style={{textAlign: 'center'}}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 26,
                      fontWeight: 'bold',
                      color: '#FF6600',
                    }}
                  >
                    {s.num}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 11,
                      color: 'rgba(255,255,255,0.45)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.06em',
                    }}
                  >
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Button
              style={{
                textTransform: 'none',
                width: '90%',
                height: 60,
                fontWeight: 'normal',
                alignItems: 'center',
                marginTop: 32,
              }}
              sx={{
                color: '#FFFFFF',
                bgcolor: '#FF6600',
                ':hover': {bgcolor: '#FFFFFF', color: '#06448E'},
              }}
              component={Link}
              to="/cadastro_ponto"
            >
              <p
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 20,
                  marginRight: 16,
                }}
              >
                Criar meu ponto
              </p>
              <ArrowForward />
            </Button>
          </div>
        </div>
      ) : (
        /* ───── DESKTOP ───── */
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 'auto',
            marginTop: 0,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            paddingTop: 60,
            paddingBottom: 60,
            boxSizing: 'border-box',
            overflow: 'hidden',
          }}
        >
          {/* Background image */}
          <img
            src={PontoIreit}
            alt=""
            aria-hidden="true"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center 40%',
            }}
          />
          {/* Blue overlay — heavy on the left for text, fades center, solid at bottom to blend with footer */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(105deg, rgba(6,68,142,0.96) 0%, rgba(6,68,142,0.88) 38%, rgba(6,68,142,0.60) 58%, rgba(6,68,142,0.35) 75%, rgba(6,68,142,0.20) 100%)',
            }}
          />
          {/* Bottom fade to match footer color exactly */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: 80,
              background:
                'linear-gradient(180deg, transparent 0%, #06448e 100%)',
            }}
          />
          {/* Orange accent line at top */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: '#FF6600',
            }}
          />

          {/* Left: text */}
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              flex: 0.55,
              paddingLeft: 60,
              paddingRight: 40,
            }}
          >
            {/* Pill badge */}
            <div
              style={{
                background: 'rgba(255,102,0,0.18)',
                border: '1px solid rgba(255,102,0,0.5)',
                borderRadius: 20,
                padding: '5px 16px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                width: 'fit-content',
                marginBottom: 16,
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  background: '#FF6600',
                  display: 'inline-block',
                }}
              />
              <p
                style={{
                  margin: 0,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#FF6600',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Novo Recurso
              </p>
            </div>

            {/* Heading */}
            <EnterFromLeft>
              <p
                style={{
                  fontSize: 56,
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  marginTop: 0,
                  marginBottom: 0,
                  lineHeight: 1.0,
                }}
              >
                Cadastre seu <span style={{color: '#FF6600'}}>ponto</span>
              </p>
              <p
                style={{
                  fontSize: 28,
                  fontWeight: 'bold',
                  color: 'rgba(255,255,255,0.5)',
                  marginTop: 8,
                  marginBottom: 0,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                }}
              >
                e gerencie sua frota
              </p>
            </EnterFromLeft>

            {/* Description */}
            <p
              style={{
                fontSize: 18,
                color: 'rgba(255,255,255,0.7)',
                marginTop: 24,
                marginBottom: 0,
                lineHeight: 1.65,
                maxWidth: 420,
              }}
            >
              Donos de pontos de mototáxi, táxi e carros de aplicativo podem
              criar seus pontos, vincular sua frota e gerenciar tudo em um só
              lugar.
            </p>

            {/* Stats */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 40,
                marginTop: 32,
                paddingTop: 24,
                borderTop: '1px solid rgba(255,255,255,0.12)',
                maxWidth: 380,
              }}
            >
              {[{num: '100%', label: 'Gratuito'}].map(s => (
                <div key={s.label}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 28,
                      fontWeight: 'bold',
                      color: '#FF6600',
                    }}
                  >
                    {s.num}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 11,
                      color: 'rgba(255,255,255,0.4)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.06em',
                      marginTop: 4,
                    }}
                  >
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                marginTop: 36,
              }}
            >
              <Button
                style={{
                  textTransform: 'none',
                  width: 220,
                  height: 60,
                  fontWeight: 'normal',
                  alignItems: 'center',
                }}
                sx={{
                  color: '#FFFFFF',
                  bgcolor: '#FF6600',
                  ':hover': {bgcolor: '#FFFFFF', color: '#06448E'},
                }}
                component={Link}
                to="/cadastro_ponto"
              >
                <p
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    fontSize: 18,
                    marginRight: 12,
                  }}
                >
                  Criar meu ponto
                </p>
                <ArrowForward />
              </Button>
            </div>
          </div>

          {/* Right: moto card */}
          <EnterFromRight
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flex: 0.45,
              justifyContent: 'center',
              alignItems: 'center',
              paddingRight: 60,
            }}
          >
            <img
              style={{
                width: '100%',
                maxWidth: 520,
                height: 300,
                borderRadius: 16,
                objectFit: 'cover',
                boxShadow:
                  '0 24px 60px rgba(0,0,0,0.5), 0 0 0 2px rgba(255,102,0,0.4)',
                display: 'block',
              }}
              src={PontoIreit}
              alt="Ponto de mototáxi IREIT"
            />
          </EnterFromRight>
        </div>
      )}
    </div>
  );
};

export default Ponto;
